import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import MuiSelect from "@mui/material/Select";

const SelectField = ({ options = [], label, InputLabelProps, fieldName, error, ...props }) => {
  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel {...InputLabelProps} id={fieldName}>
        {label}
      </InputLabel>
      <MuiSelect labelId={fieldName} id={fieldName} label={label} {...props}>
        {options.map(([value, label]) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && (
        <FormHelperText htmlFor={fieldName} error={!!error}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectField;
